import FormNewsletterSubscribe from '@/components/FormNewsletterSubscribe'
import vuewidget from './vuewidget'

export default function(dom, opts) {
  let options = {
    ...opts,
    vueComponent: FormNewsletterSubscribe,
    vueInit: null,
  }

  let page = vuewidget(dom, options)
  return page
}
